<div :class="$helper?.getSidebars?.value?.width" class="c-sidebar">
  <div class="c-sidebar-brand">
    <div class="c-sidebar-top">
      <div v-if="$helper?.getSidebars?.value?.width === 'fix-sidebar'" class="top-router">
        <router-link to="/">
          <img
            :src="require('@/assets/icons/sidebars/login-page.svg')"
            class="logo"
          />
          <div class="center-top-sidebar">
            <span class="title">DSI E-commerce</span>
            <span class="desc">A Click at all Time!</span>
          </div>
        </router-link>
      </div>
      <div @click.stop="toggleSidebar($helper?.getSidebars?.value?.width)" class="right-top-sidebar" :style="$helper?.getSidebars?.value?.width !== 'fix-sidebar' && 'margin-left: 4px;'" title="Collapse">
        <img
          v-if="$helper?.getSidebars?.value?.width === 'fix-sidebar'"
          :src="require('@/assets/icons/sidebars/menu-exstand.svg')"
          class="collapsed"
        />
        <img
          v-else
          :src="require('@/assets/icons/sidebars/menu-exstand-right.svg')"
          class="collapsed"
        />
      </div>
    </div>
    <div 
      :style="{
        padding: $helper?.getSidebars?.value?.width === 'fix-sidebar' ? 'var(--sidebar-padding)' : '10px!important'
      }"
      class="bottom-top-sidebar"
    >
      <div v-if="$helper?.getSidebars?.value?.width !== 'fix-sidebar'" class="row ">
        <div @click="toggleSidebarActive" class="bg-search">
          <img :src="require('@/assets/icons/sidebars/search.svg')" alt="">
        </div>
      </div>
      <c-input
        v-else
        v-model:value="keySearch"
        :schema="onSearch"
        placeholder="componentSearch"
        className="p10"
        searchable
      ></c-input>
    </div>
  </div>
  <div class="c-sidebar-content" :style="{
    padding: $helper?.getSidebars?.value?.width === 'fix-sidebar' ? 'var(--sidebar-padding)' : '10px!important'
  }">  
    <div v-for="(sidebar, index) in menus" :key="index" :title="$helper?.getSidebars?.value?.width !== 'fix-sidebar' ? ($i18n.locale === 'en' ? sidebar?.title : sidebar?.titleForeign) : ''" :class="$helper?.getSidebars?.value?.width !== 'fix-sidebar' ? 'min-link-item':''" class="link-item">
      <router-link @click="onSidebarClick" :to="`${sidebar?.adminRouteUrl || '/'}`" :class="(getActive(sidebar?.adminRouteUrl, $route, sidebar) || ($route?.path === '/dashboard' && (sidebar?.title === 'dashboard' || sidebar?.title === 'Dashboard'))) && 'c-link-active'">
        <img :src="sidebar?.icon ? $helper?.getFullImage(sidebar?.icon) : require('./undifined.svg')" :alt="''" style="margin-top: -1px;">
        <span v-if="$helper?.getSidebars?.value?.width === 'fix-sidebar'">{{ $i18n.locale === 'en' ? sidebar?.title : sidebar?.titleForeign }}</span>
      </router-link>
    </div>
    <div v-if="!menus.length" class="col-12 txt-center">
      <span style="font-size: var(--sidebar-font-size);color: var(--black-light);">{{ $t("errorEmpty") }}</span>
    </div>
  </div>
  <div 
    :style="{
      padding: $helper?.getSidebars?.value?.width === 'fix-sidebar' ? 'var(--sidebar-padding)' : '10px!important'
    }" 
    class="c-sidebar-footer"
  >
    <div @click.stop="isLogoutFunc(footer)" v-for="(footer, index) in footerSidebars" :key="index" :title="$helper?.getSidebars?.value?.width !== 'fix-sidebar' ? $t(footer?.title) : ''" :class="$helper?.getSidebars?.value?.width !== 'fix-sidebar' ? 'min-link-item':''" class="link-item">
      <img :src="footer?.icon || require('@/assets/icons/sidebars/login-page.svg')" :alt="$t(footer?.title)" style="margin-top: -1px;">
      <span v-if="$helper?.getSidebars?.value?.width === 'fix-sidebar'">{{ $t(footer?.title) }}</span>
    </div>
  </div>

  <c-modal
    @onClose="cancelLogout"
    @onConfirm="onLogout"
    labelText="componentSignOut"
    :active="isLogout"
  >
  </c-modal>
</div>
